import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=2a33f975"
import script from "./keyboard.vue?vue&type=script&lang=js"
export * from "./keyboard.vue?vue&type=script&lang=js"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=2a33f975&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports